import Swiper from 'swiper';
import { Pagination, EffectFade, Autoplay } from 'swiper/modules';

export function sliderShopMv() {
  if (document.querySelector('.js-shopMvSlideItem')) {
    const slideTotalNumberEle = document.getElementById('totalNumber');

    const shopMvSlideAll = document.querySelectorAll('.js-shopMvSlideItem');

    if (shopMvSlideAll.length < 2) {
      const shopMvSlideControlEle = document.querySelectorAll('.js-shopMvSlideControl');

      shopMvSlideControlEle.style.display = 'none';

      const swiper = new Swiper('.js-shopMvSlide', {
        slidesPerView: 1,
      });
    } else {
      if (shopMvSlideAll.length < 10) {
        slideTotalNumberEle.textContent = '0' + shopMvSlideAll.length;
      } else {
        slideTotalNumberEle.textContent = shopMvSlideAll.length;
      }

      const swiper = new Swiper('.js-shopMvSlide', {
        modules: [Pagination, EffectFade, Autoplay],
        pagination: {
          el: '.js-shopMvSlidePager',
        },
        effect: 'fade',
        slidesPerView: 1,
        loop: true,
        spaceBetween: 20,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        on: {
          init: function () {
            let slideSetNumber;
            let realtimeNumber = this.realIndex + 1;

            if (realtimeNumber < 10) {
              slideSetNumber = '0' + realtimeNumber;
            } else {
              slideSetNumber = realtimeNumber;
            }

            // 初期表示時
            document.getElementById('activeNumber').textContent = slideSetNumber; // 1始まり
          },
          slideChange: function () {
            let slideSetNumber;
            let realtimeNumber = this.realIndex + 1;

            if (realtimeNumber < 10) {
              slideSetNumber = '0' + realtimeNumber;
            } else {
              slideSetNumber = realtimeNumber;
            }

            document.getElementById('activeNumber').textContent = slideSetNumber; // 1始まり
          },
        },
      });
    }
  }
}
